interface NodeViewModeItem {
  id: string
  titleKey: unknown
  icon: string
}

interface NodeViewModeActive extends NodeViewModeItem {
  append?: Record<string, unknown>
  active?: boolean
}

const NODE_VIEW_MODE_IDS = {
  LIST: 'LIST',
  LIST_DENSE: 'LIST_DENSE',
}

const nodeViewModesItems: NodeViewModeItem[] = [
  {
    id: NODE_VIEW_MODE_IDS.LIST_DENSE,
    titleKey: 'node_data_table.views.list_dense',
    icon: 'far fa-bars',
  },
  {
    id: NODE_VIEW_MODE_IDS.LIST,
    titleKey: 'node_data_table.views.list',
    icon: 'fas fa-bars',
  },
]

export const useSettingsTableStore = defineStore('settingsTable', () => {
  // set node view mode from LS or default
  const localStorageNodeViewMode = useLocalStorage('NODE_VIEW_MODE', '')
  const nodeViewModeActive = ref<
    NodeViewModeItem | NodeViewModeActive | undefined
  >({
    id: NODE_VIEW_MODE_IDS.LIST,
    titleKey: 'node_data_table.views.list',
    icon: 'fas fa-bars',
  })
  const nodeViewModes = ref(nodeViewModesItems)
  const isNodeViewHiddenNodesActive = useLocalStorage(
    'NODE_VIEW_HIDDEN_NODES',
    false,
  )

  nodeViewModeActive.value =
    nodeViewModes.value.find(
      (item) => item.id === localStorageNodeViewMode.value,
    ) || nodeViewModes.value.find((item) => item.id === NODE_VIEW_MODE_IDS.LIST)

  const nodeViewModesSorted = computed(() => {
    const newActiveItem = {
      ...nodeViewModeActive.value,
      append: {
        icon: 'far fa-check',
      },
    }

    return [
      ...nodeViewModes.value.map((item) =>
        item.id !== nodeViewModeActive.value?.id
          ? { ...item, active: false }
          : {
              ...newActiveItem,
              ...item,
              active: true,
            },
      ),
    ]
  })

  const isNodeViewModeListDense = computed(() => {
    const tableSettingItemDense = nodeViewModesSorted.value.findIndex(
      (item) => item.id === NODE_VIEW_MODE_IDS.LIST_DENSE,
    )
    if (tableSettingItemDense !== -1) {
      return nodeViewModesSorted.value[tableSettingItemDense].active
    }
    return false
  })

  function setNodeViewMode(payload: NodeViewModeActive) {
    nodeViewModeActive.value = payload
    localStorageNodeViewMode.value = payload.id
  }

  return {
    // state
    nodeViewModes,
    nodeViewModesSorted,
    nodeViewModeActive,
    isNodeViewModeListDense,
    isNodeViewHiddenNodesActive,
    // actions
    setNodeViewMode,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useSettingsTableStore, import.meta.hot),
  )
}
